import { createFileRoute } from '@tanstack/react-router'

import { Cards } from '~/boundedContext/cards/pages/cards'

export const Route = createFileRoute('/demo/_layout/cards/')({
  component: () => (
    <Cards
      paths={{
        finish: '/demo/cards/finish',
        noCards: '/cards/no-cards',
        noCardsInStack: '/demo/cards/no-cards-in-stack',
      }}
      noTour
    />
  ),
})
